import { ConvexReactClient } from "convex/react";

const configuredUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

const PRODUCTION_CONVEX_URL = "https://spotted-ox-713.convex.cloud";

export const convexClient = new ConvexReactClient(configuredUrl ?? PRODUCTION_CONVEX_URL);

export const isConvexConfigured = () => true;
